import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../configure_store'

const _getState = (state: RootState) => state.products

export const getProducts = createSelector(_getState, state => state.products)

export const getProduct = (brancheCode: string) =>
  createSelector(_getState, state =>
    state.products.find(product => {
      if (!product?.branches) return false

      const claimMethod = product.branches.find(method => method.brancheCode === brancheCode)

      return !!claimMethod
    })
  )

export const getProductIsLoading = () =>
  createSelector(_getState, state => state.isLoading)

export const getAdviceProducts = createSelector(_getState, state => state.adviceProducts)
